"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Card_1 = require("@material-ui/core/Card");
const styles_1 = require("@material-ui/core/styles");
const Tab_1 = require("@material-ui/core/Tab");
const Tabs_1 = require("@material-ui/core/Tabs");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const config_1 = require("../config/config");
const TicketScreenStyle_1 = require("./jss/TicketScreenStyle");
const TicketCardContent_1 = require("./TicketCardContent");
const TicketSlider_1 = require("./TicketSlider");
const TicketTabContent_1 = require("./TicketTabContent");
class TicketCard extends React.Component {
    constructor(props) {
        super(props);
        this.onTicketSubmit = (ticketBarcodeNumber, validationNumber, tabKey) => {
            this.props.onTicketSubmit(ticketBarcodeNumber, validationNumber, tabKey);
        };
        this.showSampleTicketImage = () => {
            this.props.showSampleTicket(this.state.activeTab);
        };
        this.showSampleTicketHelpImage = (tabKey) => {
            this.props.showSampleTicketHelpImage(tabKey);
        };
        this.handleTabChange = (event, value) => {
            this.setState({ activeTab: value });
        };
        this.addTabIndex = (index) => {
            return {
                'tab-index': `${index}`
            };
        };
        this.state = {
            ticketTabs: config_1.config.internalConfig.TICKET_TABS_DATA,
            activeTab: config_1.config.internalConfig.TICKET_TABS_DATA[0].tabKey
        };
    }
    componentDidUpdate() {
        if (!!this.state.ticketTabs &&
            !!config_1.config.internalConfig.TICKET_TABS_DATA &&
            this.state.ticketTabs.length !== config_1.config.internalConfig.TICKET_TABS_DATA.length) {
            this.setState({
                ticketTabs: config_1.config.internalConfig.TICKET_TABS_DATA,
                activeTab: config_1.config.internalConfig.TICKET_TABS_DATA[0].tabKey
            });
        }
    }
    componentWillUnmount() {
        this.setState({
            activeTab: ''
        });
    }
    render() {
        const { classes, loading, t, showTicketCardView, isMobileView, theme } = this.props;
        const { ticketTabs } = this.state;
        let cardData = null;
        if (showTicketCardView && !isMobileView) {
            cardData = ticketTabs === null || ticketTabs === void 0 ? void 0 : ticketTabs.map((tab, index) => ((0, jsx_runtime_1.jsx)(TicketCardContent_1.default, { ticketTab: tab, loading: loading, onSubmit: this.onTicketSubmit, showSampleTicketHelpImage: this.showSampleTicketHelpImage, navigateToGames: this.props.navigateToGames, successfulEntered: this.props.successfulEntered, showConsentText: this.props.showConsentText, label: t(tab.tabTitle), tabLogo: tab.tabLogo, isQuickCardVisible: this.props.isQuickCardVisible, tabIndex: index, theme: theme }, tab.tabKey)));
            return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.ticketCardContainer }, { children: cardData }));
        }
        if (isMobileView) {
            cardData = ((0, jsx_runtime_1.jsx)(TicketSlider_1.default, { data: ticketTabs, loading: loading, showSampleTicketHelpImage: this.showSampleTicketHelpImage, onTicketSubmit: this.onTicketSubmit, navigateToGames: this.props.navigateToGames, successfulEntered: this.props.successfulEntered, showConsentText: this.props.showConsentText, isQuickCardVisible: this.props.isQuickCardVisible }));
            return (0, jsx_runtime_1.jsx)("div", { children: cardData });
        }
        return ((0, jsx_runtime_1.jsxs)(Card_1.default, Object.assign({ className: classes.ticketCard }, { children: [(0, jsx_runtime_1.jsx)(Tabs_1.default, Object.assign({ value: this.state.activeTab, onChange: this.handleTabChange, indicatorColor: "primary", textColor: "primary", className: classes.tabs, centered: true }, { children: ticketTabs === null || ticketTabs === void 0 ? void 0 : ticketTabs.map((tab, index) => ((0, jsx_runtime_1.jsx)(Tab_1.default, Object.assign({ label: t(tab.tabTitle), value: tab.tabKey }, this.addTabIndex(index + 1), { style: { minWidth: ticketTabs.length > 2 ? 140 : 160 } }), tab.tabKey))) })), ticketTabs === null || ticketTabs === void 0 ? void 0 : ticketTabs.map((tab, index) => this.state.activeTab === tab.tabKey && ((0, jsx_runtime_1.jsx)(TicketTabContent_1.default, { ticketTab: tab, loading: loading, onSubmit: this.onTicketSubmit, showSampleTicket: this.showSampleTicketImage, navigateToGames: this.props.navigateToGames, successfulEntered: this.props.successfulEntered, showConsentText: this.props.showConsentText }, tab.tabKey)))] })));
    }
}
exports.default = (0, styles_1.withStyles)(TicketScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(TicketCard));
//# sourceMappingURL=TicketCard.js.map